// extracted by mini-css-extract-plugin
export var box = "_8f-1";
export var checked = "_8f-2";
export var descriptionSpacer = "_8f-9";
export var disabled = "_8f-3";
export var icon = "_8f-6";
export var input = "_8f-0";
export var labelSpacer = "_8f-8";
export var medium = "_8f-5";
export var small = "_8f-4";
export var text = "_8f-7";